import { createIcon } from '@chakra-ui/react';

export const HumidityIcon = createIcon({
  displayName: 'HumidityIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '24',
    width: '24',
  },
  path: (
    <path
      d="M17.6071 10.4951L12.6354 2.5776C12.5633 2.4763 12.468 2.39371 12.3574 2.33672C12.2469 2.27973 12.1244 2.25 12 2.25C11.8756 2.25 11.7531 2.27973 11.6426 2.33672C11.532 2.39371 11.4367 2.4763 11.3646 2.5776L6.37057 10.5335C5.67689 11.6524 5.29038 12.9344 5.25 14.2502C5.25 16.0404 5.96116 17.7573 7.22703 19.0232C8.4929 20.2891 10.2098 21.0002 12 21.0002C13.7902 21.0002 15.5071 20.2891 16.773 19.0232C18.0388 17.7573 18.75 16.0404 18.75 14.2502C18.7069 12.9196 18.3126 11.6241 17.6071 10.4951ZM12 19.5006C10.6082 19.4988 9.27382 18.9451 8.28964 17.961C7.30546 16.9768 6.75177 15.6424 6.75 14.2506C6.78983 13.2016 7.10495 12.1815 7.66372 11.2927L8.36498 10.1761L15.9203 17.731C15.4296 18.2869 14.8262 18.7322 14.1504 19.0372C13.4745 19.3423 12.7415 19.5002 12 19.5006Z"
      fill="#1D85E8"
    />
  ),
});
